import { cva } from 'class-variance-authority';

const CUSTOM_VARIANTS = {
  active: 'bg-blue-lightest border-none text-blue-darker',
  inactive: 'bg-neutral-n4 border-none text-neutral-n9',
  notInUse: 'bg-neutral-n2 border-none text-neutral-n9',
  meetingRoom: 'bg-lime-lightest border-none text-lime-darker',
  projectRoom: 'bg-orange-lightest border-none text-orange-darker',
  officeCheckIn: 'bg-blue-lightest border-none text-blue-darker',
};

export const BADGE_VARIANTS = cva(
  'inline-flex items-center justify-center rounded-full border font-semibold w-fit whitespace-nowrap shrink-0 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-sm px-3 py-0.5 gap-2 h-8',
  {
    variants: {
      variant: {
        default: 'bg-brand-primary-lighter border-brand-primary-light text-brand-primary-base',
        todo: 'bg-violet-lightest border-violet-lighter text-violet-darker',
        pending: 'bg-yellow-lightest border-yellow-lighter text-yellow-darker',
        doing: 'bg-blue-lightest border-blue-lighter text-blue-darker',
        completed: 'bg-green-lightest border-green-lighter text-green-darker',
        error: 'bg-red-lightest border-red-lighter text-red-darker',
        cancelled: 'bg-neutral-n3 border-neutral-n5 text-neutral-n9',
        ...CUSTOM_VARIANTS,
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
